import { render, staticRenderFns } from "./MyAppointmentDetail.vue?vue&type=template&id=5621ae26&scoped=true&"
import script from "./MyAppointmentDetail.vue?vue&type=script&lang=js&"
export * from "./MyAppointmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyAppointmentDetail.vue?vue&type=style&index=0&id=5621ae26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5621ae26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCardActions,VContainer,VTextarea})
